module.exports = __webpack_public_path__ + "assets/images/nf-text-logo_36509293c33d99eaab9769426939e2db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nf-text-logo.png
// module id = 84
// module chunks = 0